<template>
    <div class="nrk">
        <Details  :data='data'/>
    </div>
</template>

<script>
 import{mapState} from'vuex';
export default {
    mounted() {
        if(this.$route.query.title===1){
            this.$store.dispatch('PostCasesInfo',{id:this.$route.query.id});
        }else{
            this.$store.dispatch('PostCaseTpInfo',{id:this.$route.query.id});
        }

    },
    computed:{
        ...mapState({
            data:state=>state.share.CaseTpInfodata,
        })
    },
}
</script>

<style>

</style>